import { createApp } from 'vue';
import PictToPngConverter from '../Components/PictToPngConverter.vue';

createApp(PictToPngConverter).mount('#pict-to-png-converter');
